// All FitZone services are served by the unified API (FitZone.Api); paths are unchanged,
// so every former per-service host points at it.
const apiBaseUrl = 'https://api-fitzone-dev-app.azurewebsites.net/';

export const environment = {
    production: false,
    appInsightsInstrumentationKey: '',
    azureClientId: '',
    azureTenantId: '',
    secretId: '',
    apiVersion: '1',
    host: '',
    venueServiceHost: apiBaseUrl,
    userMgmntServiceHost: apiBaseUrl,
    customerMgmtServiceHost: apiBaseUrl,
    fileMgmtServiceHost: apiBaseUrl,
    subscriptionMgmtServiceHost: apiBaseUrl,
    venueLeadServiceHost: apiBaseUrl,
    venueStaffManagementServiceHost: apiBaseUrl,
    orderMgmtServiceHost: apiBaseUrl,
    workoutMgmtServiceHost: apiBaseUrl,
    gxPlannerManagementServiceHOst: apiBaseUrl,
    venueManagementServiceHOst: apiBaseUrl,
    subscriptionRecordServiceHost: apiBaseUrl,
    attendanceServiceHost: apiBaseUrl,
    helpDeskServiceHost: apiBaseUrl,
    sessionServiceHost: apiBaseUrl,
    attendanceManagementServiceHOst: apiBaseUrl,
    fitnessAssessmentServiceHost: apiBaseUrl,
    reportManagementServiceHost: apiBaseUrl,
    rewardsManagementServiceHost: apiBaseUrl,
    contentLibraryServiceHost: apiBaseUrl,
    targetManagementService: apiBaseUrl,
    reportService: apiBaseUrl,
    workouthistoryServiceHost: apiBaseUrl,
    rewardService: apiBaseUrl,
    notificationManagementServiceHost: apiBaseUrl,
    leadGenService: apiBaseUrl,

    dashboardIds: {
        DASHBOARD: 11,
        EXPIRY_REPORT: 61,
        CHECKIN_MEMBER_REPORT: 74,
        INACTIVE_MEMBER_REPORT: 73,
        NEW_CLIENTS_REPORT: 63,
        CLIENT_ATTENDANCE_HEATMAP_REPORT: 60,
        PT_EXPIRY_REPORT: 62,
        PT_NEW_CLIENTS_REPORT: 65,
        PT_RENEWAL_REPORT: 66,
        RENEWAL_REPORT: 64,
        REVENUE_REPORT: 80,
        STAFF_ATTENDANCE_REPORT: 77,
        STAFF_ATTENDANCE_DAILY_REPORT : 78,
        STAFF_BIRTHDAY_ANNIVERSARY_REPORT: 70,
        MULTICLUB_CLIENTS_REPORT: 79,
        OLD_SETTLEMENT_REPORT:67,
        CHECK_AWAY_MEMBER_REPORT:1124

    },
    envName: 'dev'
};